//update along with app/lib/enums/report_generation_enums.py
const ReportType = {
  USER_TIME_LOG_REPORT: 'USER_TIME_LOG_REPORT',
  BRAND_CONTENT_QA_REPORT_EXPORT: 'BRAND_CONTENT_QA_REPORT_EXPORT',
  SIMILAR_BRAND_NAMES_QA_REPORT_EXPORT: 'SIMILAR_BRAND_NAMES_QA_REPORT_EXPORT',
  USER_PAYMENT_INFO_REPORT: 'USER_PAYMENT_INFO_REPORT',
  USER_THROUGHPUT_REPORT: 'USER_THROUGHPUT_REPORT',
  USER_INVOICE_REPORT: 'USER_INVOICE_REPORT',
  BRAND_DP_PRODUCTS_REPORT: 'BRAND_DP_PRODUCTS_REPORT',
  DP_PRODUCTS_BRAND_REPORT: 'DP_PRODUCTS_BRAND_REPORT',
  SUPPORT_TICKET_REPORT: 'SUPPORT_TICKET_REPORT',
};

export { ReportType };
